import Hero from "../components/Hero";
import hotelImg from "../assests/images/hotel-bg.jpg";
import {
    FaShieldAlt,
    FaLock,
    FaUserSecret,
    FaCookieBite,
    FaInfoCircle,
    FaChevronRight,
    FaCheckCircle,
    FaArrowRight,
} from "react-icons/fa";

export default function PrivacyPolicy() {
    const quickLinks = [
        "Introduction",
        "Information We Collect",
        "How We Use Data",
        "Security",
        "Sharing",
        "Cookies",
        "Your Rights",
        "Contact",
    ];

    return (
        <div className="w-full bg-[#F3F8FF]">

            {/* =====================================================
                HERO
            ===================================================== */}

            <Hero
                variant="inner"
                title="Privacy Policy"
                subtitle="Your privacy matters to us. Learn how we collect, use and protect your information."
                backgroundImage={hotelImg}
            />


            {/* =====================================================
                PRIVACY INTRO
            ===================================================== */}

            <section className="relative overflow-hidden px-4 py-12 sm:px-6 sm:py-16 lg:px-8">

                {/* Decorative background */}

                <div className="pointer-events-none absolute -right-40 top-0 h-96 w-96 rounded-full bg-[#174EA6]/8 blur-3xl" />

                <div className="pointer-events-none absolute -left-40 bottom-0 h-96 w-96 rounded-full bg-[#FFC928]/8 blur-3xl" />


                <div className="relative z-10 mx-auto max-w-7xl">

                    <div className="grid gap-6 lg:grid-cols-[1.35fr_0.65fr]">

                        {/* Main intro */}

                        <div className="relative overflow-hidden rounded-[28px] border border-slate-200 bg-white p-7 shadow-[0_15px_45px_rgba(15,23,42,0.06)] sm:p-9 lg:p-10">

                            {/* Accent */}

                            <div className="absolute left-0 top-0 h-full w-1 bg-gradient-to-b from-[#174EA6] to-[#FFC928]" />

                            <div className="flex flex-col gap-5 sm:flex-row sm:items-start">

                                <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-[#EAF3FF] text-[#174EA6]">

                                    <FaShieldAlt className="text-xl" />

                                </div>

                                <div>

                                    <div className="inline-flex items-center gap-2 rounded-full bg-[#EAF3FF] px-3 py-1.5 text-[10px] font-extrabold uppercase tracking-[0.15em] text-[#174EA6]">
                                        Your Privacy
                                    </div>

                                    <h2 className="mt-3 text-2xl font-extrabold text-[#0F172A] sm:text-3xl">
                                        Your Information Matters
                                    </h2>

                                    <p className="mt-3 max-w-3xl text-sm leading-7 text-slate-500">
                                        We are committed to protecting your
                                        personal information and maintaining
                                        your trust. This Privacy Policy explains
                                        how we collect, use and safeguard the
                                        information you provide when using our
                                        website and services.
                                    </p>

                                </div>

                            </div>

                        </div>


                        {/* Trust card */}

                        <div className="relative overflow-hidden rounded-[28px] bg-[#002B45] p-7 text-white shadow-[0_15px_45px_rgba(0,43,69,0.15)] sm:p-8">

                            <div className="pointer-events-none absolute -right-16 -top-16 h-40 w-40 rounded-full bg-[#174EA6]/30 blur-2xl" />

                            <div className="relative z-10">

                                <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-[#FFC928] text-[#002B45]">
                                    <FaLock />
                                </div>

                                <h3 className="!text-white mt-5 text-xl font-extrabold">
                                    Safe & Secure
                                </h3>

                                <p className="mt-2 text-sm leading-6 text-white/60">
                                    We take reasonable measures to help keep
                                    your personal information secure.
                                </p>

                                <div className="mt-5 space-y-3">

                                    {[
                                        "Secure information handling",
                                        "Trusted service partners",
                                        "Privacy-focused practices",
                                    ].map((item, index) => (

                                        <div
                                            key={index}
                                            className="flex items-center gap-3"
                                        >
                                            <FaCheckCircle className="shrink-0 text-[#FFC928] text-xs" />

                                            <span className="text-xs text-white/70">
                                                {item}
                                            </span>
                                        </div>

                                    ))}

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </section>


            {/* =====================================================
                MAIN POLICY AREA
            ===================================================== */}

            <section className="px-4 pb-16 sm:px-6 sm:pb-20 lg:px-8 lg:pb-24">

                <div className="mx-auto max-w-7xl">

                    <div className="grid gap-8 lg:grid-cols-[260px_1fr]">


                        {/* =================================================
                            SIDEBAR
                        ================================================= */}

                        <aside className="hidden lg:block">

                            <div className="sticky top-24 rounded-[24px] border border-slate-200 bg-white p-5 shadow-[0_10px_35px_rgba(15,23,42,0.05)]">

                                <div className="mb-5">

                                    <p className="text-[10px] font-extrabold uppercase tracking-[0.15em] text-[#174EA6]">
                                        On This Page
                                    </p>

                                    <h3 className="mt-1 text-lg font-extrabold text-[#0F172A]">
                                        Quick Navigation
                                    </h3>

                                </div>


                                <div className="space-y-1">

                                    {quickLinks.map((item, index) => (

                                        <a
                                            key={index}
                                            href={`#section-${index}`}
                                            className="
                                                group
                                                flex
                                                items-center
                                                gap-3
                                                rounded-xl
                                                px-3
                                                py-2.5
                                                text-xs
                                                font-semibold
                                                text-slate-500
                                                transition-all
                                                duration-200
                                                hover:bg-[#EAF3FF]
                                                hover:text-[#174EA6]
                                            "
                                        >

                                            <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-lg bg-[#F3F8FF] text-[9px] font-extrabold text-[#174EA6] group-hover:bg-[#174EA6] group-hover:text-white">
                                                {String(index + 1).padStart(2, "0")}
                                            </span>

                                            <span className="flex-1">
                                                {item}
                                            </span>

                                            <FaChevronRight className="text-[8px] opacity-0 transition group-hover:translate-x-0.5 group-hover:opacity-100" />

                                        </a>

                                    ))}

                                </div>

                            </div>

                        </aside>


                        {/* =================================================
                            POLICY CONTENT
                        ================================================= */}

                        <div>

                            {/* Mobile navigation */}

                            <div className="mb-6 lg:hidden">

                                <details className="group overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">

                                    <summary className="flex cursor-pointer list-none items-center justify-between px-5 py-4 text-sm font-extrabold text-[#0F172A]">

                                        <span>
                                            Privacy Policy Sections
                                        </span>

                                        <FaChevronRight className="text-xs text-[#174EA6] transition-transform group-open:rotate-90" />

                                    </summary>

                                    <div className="border-t border-slate-100 p-3">

                                        <div className="grid grid-cols-1 gap-1 sm:grid-cols-2">

                                            {quickLinks.map((item, index) => (

                                                <a
                                                    key={index}
                                                    href={`#section-${index}`}
                                                    className="flex items-center gap-3 rounded-xl px-3 py-3 text-xs font-semibold text-slate-500 transition hover:bg-[#EAF3FF] hover:text-[#174EA6]"
                                                >

                                                    <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-[#F3F8FF] text-[9px] font-extrabold text-[#174EA6]">
                                                        {String(index + 1).padStart(2, "0")}
                                                    </span>

                                                    {item}

                                                </a>

                                            ))}

                                        </div>

                                    </div>

                                </details>

                            </div>


                            {/* Content card */}

                            <div className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-[0_15px_50px_rgba(15,23,42,0.06)]">

                                {/* Top accent */}

                                <div className="h-1 w-full bg-gradient-to-r from-[#174EA6] via-[#174EA6] to-[#FFC928]" />

                                <div className="p-6 sm:p-8 lg:p-10 xl:p-12">

                                    <div className="space-y-0">

                                        <Section
                                            id="section-0"
                                            number="01"
                                            icon={<FaInfoCircle />}
                                            title="Introduction"
                                            text="We value your privacy and are committed to protecting your personal information. This Privacy Policy explains how we collect, use, and safeguard your data."
                                        />

                                        <Section
                                            id="section-1"
                                            number="02"
                                            icon={<FaUserSecret />}
                                            title="Information We Collect"
                                            list={[
                                                "Personal details such as name, email and phone number",
                                                "Booking and travel preferences",
                                                "Payment information handled through secure systems",
                                                "Usage data including cookies and analytics information",
                                            ]}
                                        />

                                        <Section
                                            id="section-2"
                                            number="03"
                                            icon={<FaInfoCircle />}
                                            title="How We Use Your Information"
                                            list={[
                                                "Process bookings and payments",
                                                "Improve our website and user experience",
                                                "Send booking confirmations and relevant communications",
                                                "Provide customer support and respond to enquiries",
                                            ]}
                                        />

                                        <Section
                                            id="section-3"
                                            number="04"
                                            icon={<FaLock />}
                                            title="Data Security"
                                            text="We use reasonable security measures, including secure systems and appropriate safeguards, to help protect your personal information from unauthorized access, misuse or disclosure."
                                        />

                                        <Section
                                            id="section-4"
                                            number="05"
                                            icon={<FaShieldAlt />}
                                            title="Sharing of Information"
                                            text="We do not sell your personal information. Information may be shared with trusted service providers or partners when necessary to provide our services, process bookings or support your requests."
                                        />

                                        <Section
                                            id="section-5"
                                            number="06"
                                            icon={<FaCookieBite />}
                                            title="Cookies"
                                            text="We use cookies and similar technologies to improve your browsing experience, understand website usage and support certain website functionality. You can manage cookies through your browser settings."
                                        />

                                        <Section
                                            id="section-6"
                                            number="07"
                                            icon={<FaUserSecret />}
                                            title="Your Rights"
                                            text="You may request access to, correction of, or deletion of your personal information where applicable. You can contact our team if you have questions or requests regarding your personal data."
                                        />

                                        <Section
                                            id="section-7"
                                            number="08"
                                            icon={<FaInfoCircle />}
                                            title="Contact Us"
                                            text="If you have any questions or concerns about this Privacy Policy or how your information is handled, please contact our support team."
                                            last
                                        />

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </section>


            {/* =====================================================
                FINAL PRIVACY BANNER
            ===================================================== */}

            <section className="px-4 pb-16 sm:px-6 sm:pb-20 lg:px-8">

                <div className="mx-auto max-w-7xl">

                    <div className="relative overflow-hidden rounded-[30px] bg-[#002B45] px-6 py-10 text-center shadow-[0_20px_60px_rgba(0,43,69,0.15)] sm:px-10 sm:py-12">

                        {/* Decorative */}

                        <div className="pointer-events-none absolute -left-24 -top-24 h-64 w-64 rounded-full bg-[#174EA6]/30 blur-3xl" />

                        <div className="pointer-events-none absolute -bottom-24 -right-24 h-64 w-64 rounded-full bg-[#FFC928]/10 blur-3xl" />


                        <div className="relative z-10 mx-auto max-w-2xl">

                            <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-[#FFC928] text-xl text-[#002B45]">
                                <FaShieldAlt />
                            </div>

                            <h2 className="mt-5 text-2xl font-extrabold !text-white sm:text-3xl">
                                Your Privacy Is Important To Us
                            </h2>

                            <p className="mt-3 text-sm leading-6 text-white/60">
                                We are committed to handling your information
                                responsibly and providing a safe experience
                                throughout your journey with us.
                            </p>

                            <a
                                href="/contact-us"
                                className="group mt-7 inline-flex items-center gap-3 rounded-xl bg-[#FFC928] px-6 py-3.5 text-sm font-extrabold text-[#002B45] shadow-lg transition-all duration-300 hover:-translate-y-0.5 hover:shadow-xl"
                            >
                                Contact Our Team

                                <FaArrowRight className="text-xs transition-transform duration-300 group-hover:translate-x-1" />
                            </a>

                        </div>

                    </div>

                </div>

            </section>

        </div>
    );
}


/* =========================================================
   REUSABLE POLICY SECTION
========================================================= */

function Section({
    id,
    number,
    icon,
    title,
    text,
    list,
    last = false,
}) {
    return (
        <div
            id={id}
            className={`scroll-mt-28 ${!last
                ? "border-b border-slate-100 pb-9 mb-9"
                : ""
                }`}
        >

            {/* Heading */}

            <div className="flex items-start gap-4">

                {/* Number */}

                <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-[#EAF3FF] text-xs font-extrabold text-[#174EA6]">

                    {number}

                </div>


                <div className="min-w-0 flex-1">

                    <div className="flex items-center gap-2.5">

                        <span className="text-sm text-[#174EA6]">
                            {icon}
                        </span>

                        <h2 className="text-xl font-extrabold text-[#0F172A] sm:text-[22px]">
                            {title}
                        </h2>

                    </div>


                    {/* Text */}

                    {text && (
                        <p className="mt-4 text-sm leading-7 text-slate-500">
                            {text}
                        </p>
                    )}


                    {/* List */}

                    {list && (
                        <div className="mt-4 space-y-2.5">

                            {list.map((item, index) => (

                                <div
                                    key={index}
                                    className="flex items-start gap-3"
                                >

                                    <span className="mt-1.5 flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-[#EAF3FF]">

                                        <FaCheckCircle className="text-[8px] text-[#174EA6]" />

                                    </span>

                                    <p className="text-sm leading-6 text-slate-500">
                                        {item}
                                    </p>

                                </div>

                            ))}

                        </div>
                    )}

                </div>

            </div>

        </div>
    );
}